import React from "react";
import { DataHistoryLastWarehouseUpdate } from "../DataHistoryLastWarehouseUpdate/DataHistoryLastWarehouseUpdate";

export function ProductLastUpdate(props) {
	const dataHistory = props.dataHistory;
	if (!dataHistory || dataHistory.length === 0) {
		return null;
	}

	const targetSourcePrefix = "product-syncer";

	const filteredDataHistory = dataHistory.filter((dhe) =>
		dhe.source.startsWith(targetSourcePrefix)
	);
	return <DataHistoryLastWarehouseUpdate dataHistory={filteredDataHistory} />;
}